<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    locale?: boolean
    returnTo?: string
    returnToText?: string
  }>(),
  {
    locale: true,
    returnTo: undefined,
    returnToText: "",
    title: undefined,
  },
)
</script>

<template>
  <header class="relative bg-white shadow-xs">
    <div
      class="mx-auto flex max-w-7xl flex-row items-center justify-between px-4 py-1.5 sm:px-6 lg:px-8 lg:py-2"
    >
      <div
        v-if="returnTo || title"
        class="flex flex-row items-center overflow-hidden"
      >
        <div v-if="returnTo" class="flex flex-row items-center">
          <NuxtLink
            class="cursor-pointer text-sm font-medium text-zinc-500 hover:text-blue-500 sm:text-base"
            :to="returnTo"
          >
            {{ returnToText }}
          </NuxtLink>
          <span class="mx-2 inline text-zinc-300">/</span>
        </div>
        <h3
          class="mr-2 inline truncate text-sm font-medium text-zinc-800 sm:text-base"
        >
          {{ title }}
        </h3>
      </div>
      <slot />
      <div>
        <HubLocaleSwitcher v-if="locale" class="w-full" />
      </div>
    </div>
  </header>
</template>
